var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproveDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1180_3129)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#BFC4CA"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1180_3129)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8154 7.05652C15.0603 7.29975 15.0617 7.69547 14.8185 7.9404L9.23254 13.5654C9.11521 13.6836 8.95558 13.75 8.78906 13.75C8.62255 13.75 8.46292 13.6836 8.34558 13.5654L5.80652 11.0086C5.5633 10.7637 5.56467 10.3679 5.8096 10.1247C6.05453 9.88148 6.45025 9.88286 6.69348 10.1278L8.78906 12.238L13.9315 7.0596C14.1747 6.81467 14.5705 6.8133 14.8154 7.05652Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1180_3129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1180_3129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.375,
    height: 6.875,
    fill: "white",
    transform: "translate(5.625 6.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveDisabled);
export default __webpack_public_path__ + "static/media/approve_disabled.d0de94726f5f736a588f37dd747b2cbf.svg";
export { ForwardRef as ReactComponent };